module.exports = __webpack_public_path__ + "static/media/desktop_separator_05.dae2e08b.webp";